export default function DoneForDay() {
  return (
    <div className="done">
      <h3>🎉 Congratulations! 🎉</h3>
      <h6>You're done for the day!</h6>
      <h6>
        Rest easy and look forward to more Hebrew and Greek translating joy
        tomorrow! 🤓
      </h6>
    </div>
  );
}
